import { SAUVEGARDE_LABELS } from "utils";
import { EtatLigne, ResultatEnLigne, ResultatSauvegarde } from "views/admin/maintenance/suivi";

// Libellés des états de la page Maintenance WordPress, partagés par la liste et le panneau de détail
export const ETAT_LIGNE_LABELS: Record<EtatLigne, string> = {
  a_traiter: "À traiter",
  a_surveiller: "À surveiller",
  partiel: "Partiel",
  non_collecte: "Non collecté",
  a_jour: "À jour",
};
export const SAUVEGARDE_ETAT_LABELS: Record<ResultatSauvegarde["etat"], string> = {
  ok: "OK",
  echec: "Échec",
  echec_envoi: "Échec d'envoi",
  aucune: "Aucune configurée",
  en_retard: "En retard",
  avertissement: "Avertissement",
  jamais: "Jamais exécutée",
  autre: SAUVEGARDE_LABELS.autre,
  non_prevue: SAUVEGARDE_LABELS.aucune,
  non_collecte: "Non collecté",
};
export const EN_LIGNE_LABELS: Record<ResultatEnLigne["etat"], string> = {
  en_ligne: "En ligne",
  contenu_anormal: "Contenu anormal",
  hors_ligne: "Hors ligne",
  a_verifier: "À vérifier",
  non_collecte: "Non collecté",
};
